export const copyToClipboard = async (str: string): Promise<boolean> => {
  let success = false;

  try {
    await navigator.clipboard.writeText(str);
    success = true;
  } catch (err) {
    const textArea = document.createElement("textarea");
    try {
      textArea.value = str;
      textArea.setAttribute("readonly", "");
      textArea.style.position = "absolute";
      textArea.style.left = "-9999px";
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      success = document.execCommand("copy");
      // If a selection existed before copying, restore the original selection
    } catch (err) {
      console.log("error copying to clipboard", err);
    } finally {
      document.body.removeChild(textArea);
    }
  }

  return success;
};
